module.exports = {
  lang: '中文',
  login: {
    login: '登录',
    loginTitle: '欢迎登录',
  },
}
